'use client';

import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { LoggedInHome } from './components/logged-in-home';

interface AihumanitDashboardClientProps {
    session: Session;
}

function AihumanitDashboardWrapper({ session }: AihumanitDashboardClientProps) {
    return <LoggedInHome session={session} />;
}

// Main export that wraps with SessionProvider
export default function AihumanitDashboardClient({ session }: AihumanitDashboardClientProps) {
    return (
        <SessionProvider refetchOnWindowFocus={false} refetchInterval={0} session={session}>
            <AihumanitDashboardWrapper session={session} />
        </SessionProvider>
    );
}